import type { CSSProperties, ElementType, HTMLAttributes, ReactNode } from 'react';

export type SectionLabelTone = 'accent' | 'muted' | 'body';

export interface SectionLabelProps extends Omit<HTMLAttributes<HTMLElement>, 'style'> {
  readonly children?: ReactNode;
  readonly tone?: SectionLabelTone;
  readonly size?: number;
  readonly style?: CSSProperties;
  readonly as?: ElementType;
}

/** Étiquette de section en capitales espacées : MISSIONS DU JOUR, PENSÉE DU JOUR, CORPS… */
export function SectionLabel({
  children,
  tone = 'accent',
  size = 11,
  style,
  as: Tag = 'div',
  ...rest
}: SectionLabelProps) {
  return (
    <Tag
      {...rest}
      style={{
        fontFamily: 'var(--font-ui)',
        fontSize: size,
        fontWeight: 500,
        letterSpacing: 'var(--tracking-label)',
        textTransform: 'uppercase',
        color:
          tone === 'accent' ? 'var(--accent)' : tone === 'muted' ? 'var(--text-muted)' : 'var(--text-body)',
        ...style,
      }}
    >
      {children}
    </Tag>
  );
}
